import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Subscription} from "rxjs";
import {Sede} from "../../Admin/models/Sede";
import {ClassicType} from "../../shared/models/ClassicType";
import {ApiRestService as ClientApiRestService} from "../../Admin/_service/api-rest.service";
import {ApiRestService as FormazioneApiRestService} from "../_services/api-rest.service";
import {AziendeStoreService} from "../../Admin/_service/aziende-store.service";
import {FormazioneStoreService} from "../_services/formazione-store.service";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {SedeCorso} from "../_Models/sede-corso";

@Component({
  selector: 'app-sedi-edit',
  templateUrl: './sedi-edit.component.html'
})
export class SediEditComponent implements OnInit {
  subscriptions: Subscription = new Subscription();
  @Input() sedeType: "Formazione" | "Cliente" = "Formazione";
  @Input() selectedSede: SedeCorso = undefined;
  @Output() selectedSedeChange = new EventEmitter<SedeCorso>();
  tipologieSedi: ClassicType[] = [];
  dropdownSettings = {
    singleSelection: false,
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    idField: 'id',
    textField: 'label',
    itemsShowLimit: 5,
    allowSearchFilter: true,
  };
  constructor(
    private clientApiRestService: ClientApiRestService,
    private formazioneApiRestService: FormazioneApiRestService,
    private aziendeStore: AziendeStoreService,
    private formazioneStore: FormazioneStoreService,
    private modalService: NgbModal,
  ) { }

  ngOnInit() {
    this.aziendeStore.getTipologieSedi();
    this.subscriptions.add(this.aziendeStore.$tipologieSedi.subscribe((items) => {
      if (items && items !== null)
        this.tipologieSedi = items;
    }));
    if(this.sedeType == "Formazione")
      this.subscriptions.add(this.formazioneStore.$sede.subscribe((items) => {
        if (items && items !== null)
          this.selectedSede = items;
      }));
  }
  fulladdr(tizio: Sede) : string{
    var addr: string= "";
    if(tizio.indirizzo)
      addr = addr+tizio.indirizzo;
    if(tizio.citta) {
      addr = addr + ",";
      addr = addr + tizio.citta;
    }
    if(tizio.provincia) {
      addr = addr + ",";
      addr = addr + tizio.provincia;
    }
    return addr;
  }
  saveModalButton() {
    this.selectedSede.tipiSede = this.indexArray(this.selectedSede.tipiObject);
    // this.clientApiRestService.getCoordinate(this.fulladdr(this.selectedSede)).subscribe(response => {
    //   if (response.results && response.results.length > 0  && response.results[0].geometry && response.results[0].geometry.location) {
    //     this.selectedSede.lat = response.results[0].geometry.location.lat;
    //     this.selectedSede.lon = response.results[0].geometry.location.lng;
    if (this.selectedSede && !isNaN(this.selectedSede.id))
      this.clientApiRestService.updateSedi(this.selectedSede).subscribe(data => {
        if(this.sedeType == "Cliente")
          this.aziendeStore.Refresh_data();
        else if (this.sedeType == "Formazione")
          this.formazioneStore.updateStoredEdizione();
        this.selectedSedeChange.emit(data);
        this.closeBtnClick()
      });
    else if (this.selectedSede && (isNaN(this.selectedSede.id) || this.selectedSede.id < 1))
      this.clientApiRestService.addNewSedi(this.selectedSede).subscribe(data => {
        if(this.sedeType == "Cliente")
          this.aziendeStore.Refresh_data();
        else if (this.sedeType == "Formazione")
          this.formazioneStore.updateStoredEdizione();
        this.selectedSedeChange.emit(data);
        this.closeBtnClick()
      });

    //   }
    // }, error =>{}, () => {
    // })
  }
  indexArray(input: ClassicType[]) {
    const output: number[] = [];
    input.forEach(data => output.push(parseInt(data.id)));
    return output;
  }
  closeBtnClick() {
    this.modalService.dismissAll();
  }

}
